export default (specificity: string) => {
  const allowed = ['about', 'at least'];

  if (allowed.indexOf(specificity.toLowerCase()) !== -1) {
    return specificity;
  }

  return false;
};
